import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { nameof } from 'ts-simple-nameof';
import { LoginService } from '../../../../../../../libs/utils/auth-shared/src/lib/services/login.service';
import { GridMenuItem } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid-menu/grid-menu-item';
import { GridComponent, RowClass } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid.component';
import { FilterType } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/filter-type';
import { CellValueType, IGridColumn } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/grid-column';
import { IGridFilter } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/grid-filter';
import { Icons } from '../../../../../../../libs/utils/ng-shared-components/src/lib/icon/icons';
import { ModalService } from '../../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { enumName_mi_shared } from '../../../../../../../libs/utils/ts-shared/src/lib/api/enums/_enumName.mi_shared';
import { PagedSearchDto } from '../../../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedSearchDto';
import { moduleName } from '../../../../../../../libs/utils/ts-shared/src/lib/module-names';
import { BankAccountDto } from '../../../../api/dtos/BankAccountDto';
import { BankAccountFiltersDto } from '../../../../api/dtos/BankAccountFiltersDto';
import { ApiAdminBankAccount } from '../../../../api/endpoints/ApiAdminBankAccount';
import { ApiClientAdminBankAccount } from '../../../../api/endpoints/ApiClientAdminBankAccount';
import { HttpApiRequestOptions } from '../../../../api/endpoints/HttpApiRequestOptions';
import { enumName_mi_pspc } from '../../../../api/enums/_enumName.mi_pspc';
import { Roles } from '../../../../api/enums/Roles';
import { TrackingPopupComponent } from '../../../components/track-grid/tracking-popup.component';
import { RelatedEntityIssuePopupService } from '../../issue/related-entity-issue-popup/related-entity-issue-popup.service';
import { BankAccountAddAssociatedPersonComponent } from './bank-account-add-associated-person.component';
import { BankAccountCreateComponent } from './bank-account-create.component';
import { BankAccountEditComponent } from './bank-account-edit.component';

@Component({
  standalone: false,
  selector: 'mf-bank-account-grid',
  templateUrl: './bank-account-grid.component.html',
  styleUrls: ['./bank-account-grid.component.scss'],
})
export class BankAccountGridComponent {
  constructor(
    private _apiClientAdminBankAccount: ApiClientAdminBankAccount,
    private _apiAdminBankAccount: ApiAdminBankAccount,
    private _modalService: ModalService,
    private _activatedRoute: ActivatedRoute,
    private _loginService: LoginService,
    private _relatedEntityIssuePopupService: RelatedEntityIssuePopupService
  ) {
    if (this._activatedRoute.snapshot.queryParams.id) {
      this.initialFilters.id = this._activatedRoute.snapshot.queryParams.id;
    }
  }
  @ViewChild('grid')
  grid: GridComponent;
  bankAccount: BankAccountDto;

  globalFilters: IGridFilter[] = [
    {
      header: 'Tipo de titular',
      propertyName: nameof<BankAccountFiltersDto>((b) => b.personType),
      type: FilterType.Enum,
      enumName: enumName_mi_shared.PersonType,
      enumNameModule: moduleName.shared,
    },
    {
      header: 'Incluir Inactivas',
      propertyName: nameof<BankAccountFiltersDto>((b) => b.includeInactive),
      type: FilterType.Boolean,
    },
  ];

  initialFilters = new BankAccountFiltersDto();

  columns: IGridColumn<BankAccountDto>[] = [
    {
      field: nameof<BankAccountDto>((p) => p.holderName),
      header: 'Titular',
      width: 10,
      filter: {
        propertyName: nameof<BankAccountFiltersDto>((p) => p.holderName),
        type: FilterType.Text,
      },
    },
    {
      header: 'Banco',
      field: nameof<BankAccountDto>((p) => p.bank.name),
      filter: { propertyName: nameof<BankAccountFiltersDto>((p) => p.bank), type: FilterType.Entity, entityType: 'Bank' },
      width: 5,
    },
    {
      field: nameof<BankAccountDto>((p) => p.bankBranch.name),
      header: 'Sucursal',
      width: 5,
    },
    {
      header: 'Número',
      field: nameof<BankAccountDto>((p) => p.accountNumber),
      filter: { propertyName: nameof<BankAccountFiltersDto>((p) => p.accountNumber), type: FilterType.Text },
      width: 8,
    },
    {
      field: nameof<BankAccountDto>((p) => p.currency),
      header: 'Moneda',
      width: 4,
      cellOptions: {
        type: CellValueType.Enum,
        enumName: enumName_mi_pspc.Currency,
      },
      filter: {
        propertyName: nameof<BankAccountFiltersDto>((p) => p.currencyList),
        type: FilterType.EnumList,
        enumName: enumName_mi_pspc.Currency,
      },
    },
    {
      field: nameof<BankAccountDto>((p) => p.accountType),
      header: 'Tipo',
      width: 5,
      cellOptions: { type: CellValueType.Enum, enumName: enumName_mi_pspc.AccountType },
    },
    {
      header: 'Verificada',
      field: nameof<BankAccountDto>((p) => p.isVerified),
      filter: { propertyName: nameof<BankAccountFiltersDto>((p) => p.isVerified), type: FilterType.Boolean },
      width: 5,
      cellOptions: { type: CellValueType.Boolean },
    },
  ];

  menuItems: GridMenuItem[] = !this._loginService.userIsInRole([Roles[Roles.SuperAdmin]])
    ? [
        {
          label: 'No disponible',
          icon: Icons.clear,
          onClick: () => {},
        },
      ]
    : [
        {
          label: 'Editar',
          icon: Icons.edit,
          onClick: (bankAccountDto: BankAccountDto) => {
            this._modalService.openRightModal(BankAccountEditComponent, {
              openData: bankAccountDto.id,
              onCloseSuccess: () => {
                this._relatedEntityIssuePopupService.checkRelatedIssuesAndOpenPopup(bankAccountDto.id);
                this.grid.reloadPage();
              },
            });
          },
        },
        {
          label: 'Inactivar',
          icon: Icons.delete,
          onClick: (bankAccountDto: BankAccountDto) => {
            this._modalService.openYesOrNoModal({
              openData: {
                title: '¿Está seguro de inactivar la cuenta bancaria?',
              },
              onCloseSuccess: async () => {
                await this._apiAdminBankAccount.inactivate(bankAccountDto.id);
                this.grid.reloadPage();
              },
            });
          },
        },
        {
          label: 'Ver tracking',
          icon: Icons.list,
          onClick: (bankAccountDto: BankAccountDto) => {
            this._modalService.openLargeModal(TrackingPopupComponent, {
              openData: bankAccountDto.id,
              onCloseSuccess: async () => {},
            });
          },
        },
        {
          label: 'Personas asociadas',
          icon: Icons.edit,
          onClick: (bankAccountDto: BankAccountDto) => {
            this._modalService.openRightModal(BankAccountAddAssociatedPersonComponent, {
              openData: bankAccountDto.id,
              onCloseSuccess: () => {
                this.grid.reloadPage();
              },
            });
          },
        },
      ];

  apiEndpoint = (search: PagedSearchDto<BankAccountFiltersDto>, httpApiRequestOptions: HttpApiRequestOptions) =>
    this._apiClientAdminBankAccount.getPaged(search, httpApiRequestOptions);

  getRowClass(row: any) {
    if (!row.item.inactive) {
      return null;
    }
    return RowClass.Inactive;
  }

  openNewBankAccountPopup() {
    this._modalService.openRightModal(BankAccountCreateComponent, {
      onCloseSuccess: () => {
        this.grid.reloadPage();
      },
    });
  }
}
